<template>
    <thead>
        <slot />
    </thead>
</template>

<script setup>
defineOptions({
    name: 'ZenGridHeader',
})
</script>
